import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import horses from './modules/horses'
import equipment from './modules/equipment'
import gender from './modules/gender'
import age from './modules/age'
import tasks from './modules/tasks'
import people from './modules/people'
import lots from './modules/lots'
import jobs from './modules/jobs'
import locations from './modules/locations'
import countries from './modules/countries'
import account from './modules/account'
import tenant from './modules/tenant'
import plans from './modules/plans'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
		app,
		horses,
		equipment,
		gender,
		age,
		tasks,
		people,
		lots,
		jobs,
		locations,
		countries,
		account,
		tenant,
		plans
	},
	strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js